// extracted by mini-css-extract-plugin
export default {"banner":"PwaOfflineBanner_banner__DAh4a","text":"PwaOfflineBanner_text__w7q++"};